// ---------- import external depemdencies ----------
import React from "react";

// --------- import internal dependencies -----------
import "./dashboardlayout.scoped.css";
import SideNav from "../../components/SideNav";
import Header from "../../components/Header";

type Props = {
  page: string;
  children: React.ReactNode;
};

function DashboardLayout({ page, children }: Props) {
  return (
    <>
      <main>
        <SideNav />
        <section className="main-content">
          <Header heading={page} />
          {children}
        </section>
      </main>
    </>
  );
}

export default DashboardLayout;
